import { forwardRef } from 'react';
import { Card as SharedCard, type CardProps as SharedCardProps } from 'pi-kiosk-shared/ui';

export type CardProps = Omit<SharedCardProps, 'surface'>;

/** C7/C10 — live Card uses rounded-xl + soft --shadow-card. */
const CUSTOMER_VCL_SURFACE_BASE =
  'rounded-[var(--vcl-surface-radius-xl)] shadow-[var(--vcl-elevation-card)]';

/** C5 — live padded Card `p-4 sm:p-6`. */
const CUSTOMER_VCL_PADDED =
  'p-[var(--vcl-surface-pad-md)] sm:p-[var(--vcl-surface-pad-lg)]';

/** C10 elevated — soft popover elevation. */
const CUSTOMER_VCL_ELEVATED = 'shadow-[var(--vcl-elevation-popover)]';

/**
 * Customer Card adapter — binds C5/C7/C10 to `--vcl-*` without editing shared
 * `kioskCustomerCard` (also used by kiosk).
 */
export const Card = forwardRef<HTMLDivElement, CardProps>((props, ref) => {
  const { className, padded, elevated, ...rest } = props;
  const merged = [
    CUSTOMER_VCL_SURFACE_BASE,
    padded !== false ? CUSTOMER_VCL_PADDED : undefined,
    elevated === true ? CUSTOMER_VCL_ELEVATED : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <SharedCard
      ref={ref}
      surface="customer"
      padded={padded}
      elevated={elevated}
      className={merged}
      {...rest}
    />
  );
});
Card.displayName = 'Card';
